// extracted by mini-css-extract-plugin
export default {"inline":"Inline_inline__Jldok"};